import { Button, EmbedUrlRequest } from 'vopay';
import { FC, ReactNode, useEffect, useState } from 'react';
import usePostEmbedUrl from '../../hooks/useApi/usePostEmbedUrl';
import styles from './ElinxConnect.module.scss';

export type ElinxConnectProps = {
  setting: EmbedUrlRequest;
  onSuccess?: (eventValues: EventMessage) => void;
  onClose: () => void;
  loadingMessage?: ReactNode;
};
export type EventMessageData = {
  Step: 'LINK';
  Institution: string;
  Url: string;
  Token: string;
  BankId: string;
  PaymentMethod: 'bank' | 'creditcard' | 'debitcard';
  CreditCardNumber: string;
  CreditCardHolderName: string;
  CreditCardBrand: string;
  CreditCardExpiryYear: string;
  CreditCardExpiryMonth: string;
  [key: string]: string;
};
export type EventMessage = {
  data: EventMessageData;
};

const ElinxConnect: FC<ElinxConnectProps> = ({ setting, onSuccess, onClose, loadingMessage }) => {
  const [url, setUrl] = useState('');
  const [embedUrlResponse, postEmbedUrlResponse] = usePostEmbedUrl({});
  useEffect(() => {
    const handleMessage = (event: EventMessage) => {
      if (event.data.Step === 'LINK') {
        onSuccess?.(event);
      }
    };

    window.addEventListener('message', handleMessage, false);
    return () => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, []);
  useEffect(() => {
    postEmbedUrlResponse(setting);
  }, [setting]);
  useEffect(() => {
    if (embedUrlResponse.Success) {
      setUrl(embedUrlResponse.EmbedURL);
    }
  }, [embedUrlResponse]);
  return (
    <div className={styles.IframeContainer}>
      <div className={styles.IframeClose}>
        <Button
          id="close-elinx"
          label=""
          noShadow
          noPadding
          height="50px"
          width="50px"
          onClick={onClose}
          icon="close"
          iconLocation="center"
          iconSize="xlg"
          color="secondary"
        />
      </div>

      {loadingMessage}

      {url && <iframe className={styles.Iframe} src={url} title="eLinx" seamless />}
    </div>
  );
};

export default ElinxConnect;
